const modals = {
  findPhoneModal: {
    getPhoneNum: '',
  },
};

export default modals;
